import { render, staticRenderFns } from "./SmallSummary.vue?vue&type=template&id=4e15432e&"
import script from "./SmallSummary.vue?vue&type=script&lang=js&"
export * from "./SmallSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports